import React from 'react';
import {connect} from 'react-redux';

import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';

import audioNo from 'assets/sounds/no/5 1 Leseforstaelse Intro.mp3';
import audioNn from 'assets/sounds/nn/5 1 Leseforstaelse Intro.wav';

import tutorialVideo from './assets/99c06a75c2d10f2ad5d81a1aa870fc65.mp4';

class Intro extends React.Component {
	constructor(props) {
		super(props);

		const audioObj = {
			no: audioNo,
			nn: audioNn,
		};
		this.leseprovenIntro = this.props.isNorming
			? strings.leseprovenIntroNorming
			: strings.leseprovenIntro;

		this.leseprovenTimeLimit = this.props.isNorming
			? strings.leseprovenTimeLimitNorming
			: strings.leseprovenTimeLimit;

		this.audio = audioObj[strings.getLanguage()];
		this.videoRefView = React.createRef();
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div>
				<div
					className={
						this.props.isNorming ? 'text-center' : 'text-left'
					}
				>
					<p>
						<AudioPlayer
							autoplay
							inline
							onPause={() => {
								videoRef.play();
							}}
							onStart={() => {
								const scrollActionTime = 30200;

								if (scrollActionTime) {
									setTimeout(() => {
										if (this.videoRefView.current) {
											this.videoRefView.current.scrollIntoView(
												{
													behavior: 'smooth',
													block: 'start',
												}
											);
											videoRef.play();
										}
									}, scrollActionTime);
								}
							}}
							src={this.audio}
							onErrorPlay={() => {
								console.log('Something went wrong');
							}}
						/>
						{this.leseprovenIntro}
					</p>
					<p>{this.leseprovenTimeLimit}</p>
				</div>

				<div className="lit-preview" ref={this.videoRefView}>
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={tutorialVideo}
					/>
				</div>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
